export const GET_CAMPAIGNS_QUERY = `
  query GetCampaigns(
    $where: CampaignFilterInput
    $order: [DynamicSortInput!]
    $paging: PaginationInput
  ) {
    getCampaigns(where: $where, order: $order, paging: $paging) {
      items {
        CampaignEvent
        CampaignMediaDetails {
          MediaId
          CampaignType
          Entity
          Filter
          Subject
          Templet
        }
        CampaignPublishGraphQLQuery
        CronExpression
        CustomFromAddress
        DatePublished
        EmailPublishingDetailForTargetAll
        EndDate
        IsArchived
        IsASignUpCampaign
        IsCampaignTargetAll
        IsGraphQLQueryBySegmentWise
        IsMarkedToDelete
        IsRecurringOrScheduled
        Language
        LoginLinkExpiryDate
        MetaTags
        Name
        OrganizationId
        Priority
        RecipientsToAddForTargetAll
        RecipientsToRemoveForTargetAll
        ScheduledorRecurringStatus
        ScheduleTime
        TimeZone
        SegmentationType
        StartDate
        Status
        Tags
        TargetAudience
        TenantId
        TimesSent
        TotalRecipent
        Type
        ItemId
        CreatedDate
        LastUpdatedDate
        CreatedBy
        LastUpdatedBy
      }
      totalCount
      pageNo
      pageSize
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
`;

export const GET_CAMPAIGN_SEGMENTS_QUERY = `
  query GetCampaignSegments(
    $where: CampaignSegmentFilterInput
    $order: [DynamicSortInput!]
    $paging: PaginationInput
  ) {
    getCampaignSegments(where: $where, order: $order, paging: $paging) {
      items {
        ItemId
        CreatedDate
        LastUpdatedDate
        CreatedBy
        Language
        LastUpdatedBy
        OrganizationId
        Tags
        Name
        Description
        CustomFilter
      }
      totalCount
      pageNo
      pageSize
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
`;
